const imageFormatReg = /(.*?)\.(jpg|jpeg|png|gif|bmp)$/;

export const isImage = (val) => {
  return imageFormatReg.test(val)
}
